<template>
  <TBadge v-if="displayAmenities.length">
    <div class="flex items-center gap-2 py-1">
      <TIcon
        v-for="amenity in visibleAmenityIcons"
        :key="amenity"
        :icon="AMENITY_ICONS[amenity]!"
        fixed-width
      />
      <span
        v-if="overflowCount"
        class="shrink-0 text-sm font-medium text-gray-500"
      >
        +{{ overflowCount }}
      </span>
    </div>
  </TBadge>
</template>

<script setup lang="ts">
import { AMENITY_ICONS } from '~/constants/campground'
import type { CampgroundAmenity } from '~/types/campground'

const props = withDefaults(defineProps<{
  amenities: CampgroundAmenity[]
  maxVisibleAmenities?: number
}>(), {
  maxVisibleAmenities: 5,
})

const displayAmenities = computed(() => {
  return props.amenities.filter((amenity) => AMENITY_ICONS[amenity])
})

const visibleAmenityIcons = computed(() => {
  const list = displayAmenities.value
  if (list.length <= props.maxVisibleAmenities) {
    return list
  }
  return list.slice(0, props.maxVisibleAmenities - 1)
})

const overflowCount = computed(() => {
  const n = displayAmenities.value.length
  if (n <= props.maxVisibleAmenities) {
    return 0
  }
  return n - (props.maxVisibleAmenities - 1)
})
</script>
